import React from "react";
import "./ShipmentUpdateCard.scss";
import "../ShipmentUpdate.scss";
import { Button } from "antd";
import { getUpdateIcon } from "../../../utils/images";
import { receiveTrackingNotification } from "../../../services/shipments";
import { useNavigate } from "react-router-dom";

const ShipmentUpdateCard = ({ update, refetch }) => {
  const navigate = useNavigate();

  function handleUpload(path) {
    receiveTrackingNotification(update.id)
    navigate(path)
  }

  function handleReceived() {
    receiveTrackingNotification(update.id)
    refetch()
  }

  return (
    <div className="ShipmentUpdateCard">
      <div className="update-card-wrapper">
        <div className="update-card">
          <div className="content-wrapper">
            <div>
              <img src={getUpdateIcon(update.icon)} />
            </div>
            <div className="content">
              <div className="content-header">
                {
                  (update.booking_number || update.bl) && (
                    <div className="content-booking">
                      {update.booking_number || update.bl}
                    </div>
                  )
                }
                <div className="content-date">
                  {update.date}
                </div>
              </div>
              <div className="content-title">
                {update.title}
              </div>
              <div className="content-body">
                {update.message}
              </div>
            </div>
          </div>
          <div className="action-btn">
            {
              update.kind === 'document'
                ?
                <Button className="bold-btn" onClick={() => handleUpload(update.url)}>Upload</Button>
                :
                <Button className="engraved-btn" onClick={handleReceived}>Received</Button>
            }
          </div>
        </div>
      </div>
    </div>
  )
}

export default ShipmentUpdateCard;
